/* Runs before the deferred bundle app. Localize its display labels while
   preserving slot IDs, variant IDs, quantities, and bundle configuration. */
(function () {
  'use strict';
  var element = document.querySelector('[data-ckb-config]');
  var types = window.CK && window.CK.types;
  if (!element || !types || document.documentElement.lang !== 'ar') return;
  try {
    var data = JSON.parse(element.textContent);
    if (!data.config || !Array.isArray(data.config.slots)) return;
    if (location.hostname === '127.0.0.1' || location.hostname === 'localhost') data.shop.root = '/';
    data.config.slots.forEach(function (slot) {
      slot.title = types[slot.title] || slot.title;
      (slot.options || []).forEach(function (option) {
        option.label = types[option.label] || option.label;
      });
    });
    element.textContent = JSON.stringify(data);
  } catch (error) {
    // An unexpected app format must not stop the original picker mounting.
    console.warn('[ckushy] Could not localize bundle labels.', error);
  }
})();
